export const DietAllergen = (json: IDietAllergen): IDietAllergenModel => {
	const { name, name_trans, is_active, created_at, updated_at, ...rest } = json

	return {
		isActive: is_active,
		name: typeof name === 'string' ? name : LangContentToModel(name),
		nameTrans: name_trans,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		...rest,
	}
}

export const dietAllergenToJSON = (obj: Partial<IDietAllergenUpdatePayload>): Partial<IDietAllergen> => {
	const { isActive, name, ...rest } = obj

	let nameValue: string | ReturnType<typeof LangContentToJson> | undefined
	if (typeof name === 'string') {
		nameValue = name
	} else if (name) {
		nameValue = LangContentToJson(name)
	} else {
		nameValue = undefined
	}

	return {
		...rest,
		name: nameValue,
		is_active: isActive,
	}
}

export const dietAllergenUpdateToPayload = (
	allergen: IDietAllergenModel,
	updated: IDietAllergenUpdate,
): Partial<IDietAllergen> => {
	const { name, isActive, ...rest } = allergen

	return {
		...rest,
		code: updated.code,
		is_active: isActive,
		name: LangContentToJson(name, updated.name),
	}
}

export const dietAllergenCreateToPayload = (data: IDietAllergenUpdate, isActive = true): Partial<IDietAllergen> => {
	const { name, ...rest } = data

	return {
		...rest,
		is_active: isActive,
		name: generateLangContentArray(name),
	}
}
